import { gql } from '@apollo/client';

export const QL_UPDATE_ASSET = gql`
  mutation updateAsset($args: UpdateAssetInput) {
    asset {
      update(args: $args) {
        status
        product
        version
        vendor
        name
        id
        type
        updatedAt
      }
    }
  }
`;

//v3
export const GET_ASSET = gql`
  query asset($args: AssetInput) {
    asset(args: $args) {
      id
      status
      updatedAt
      createdAt
      name
      vendor
      product
      version
      assetCpe
      firstAnalysisTime
      type
      sha256
      hasRemediation
      assetGroupCount
      assetGroupIds
      quantumCapable
      sizeBytes
      risk {
        score
        category
      }
    }
  }
`;

export const GET_ASSET_WITH_ANALYTICS = gql`
  query assetWithAnalytics($args: AssetInput, $includeLicenseIssues: Boolean = false, $includeAiRelatedDependencies: Boolean = false) {
    asset(args: $args) {
      id
      status
      updatedAt
      createdAt
      name
      vendor
      product
      version
      assetCpe
      firstAnalysisTime
      type
      sha256
      hasRemediation
      assetGroupCount
      assetGroupIds
      quantumCapable
      sizeBytes
      risk {
        score
        category
      }
      analytic {
        vulnerability {
          critical
          high
          medium
          low
        }
        exploit {
          threatActor
          ransomware
          botnet
          inTheWild
          knownAttacks
          inKnownExploitedVulnerabilities
          exploitCode
        }
        components {
          application
          framework
          library
          container
          device
          kernel
          package
          kernelModule
          os
          aiModel @include(if: $includeAiRelatedDependencies)
        }
        misconfigurations {
          passed
          failed
          notApplicable
        }
        cryptography {
          publicKey
          privateKey
          certificate
        }
        binaries
        credentials {
          credential
          hash
          crackedCred
          crackedHash
          secrets
        }
        files
        licenseIssues @include(if: $includeLicenseIssues)
        aiComponents @include(if: $includeAiRelatedDependencies)
      }
    }
  }
`;

//v3
export const GET_ASSET_GROUP_ANALYTIC = gql`
  query assetGroupAnalytics($args: AssetGroupAnalyticsInput!) {
    assetGroupAnalytics(args: $args) {
      totalComponents
      exploits
      misconfigurations
      invalidCertificates
      crackedCredentials
    }
  }
`;

export const GET_ASSET_STATUS = gql`
  query assetStatus($args: AssetStatusInput!) {
    assetStatus(args: $args) {
      assetId
      lastUpdatedTime
      hasRunningJob
    }
  }
`;

export const GET_ASSET_UPLOAD = gql`
  query assetUpload($args: AssetUploadInput) {
    assetUpload(args: $args) {
      uploadId
      assetId
      uploaded
    }
  }
`;

export const GET_ASSETS_NAMES = gql`
  query assetsNamesRelay($args: AssetsRelayInput!) {
    assetsRelay(args: $args) {
      edges {
        node {
          assetId: id
          name
          status
          sha256
        }
      }
    }
  }
`;
export const GET_GROUP_ASSETS_NAMES = gql`
  query assetGroupMembers($args: AssetGroupMembersInput!) {
    assetGroupMembers(args: $args) {
      edges {
        node {
          assetId: id
          name
          sha256
          status
        }
      }
    }
  }
`;

export const GET_GROUP_MEMBERS = gql`
  query assetGroupMembers($args: AssetGroupMembersInput!) {
    assetGroupMembers(args: $args) {
      edges {
        cursor
        node {
          id
          name
          vendor
          assetGroupCount
          assetGroupIds
          product
          version
          createdAt
          updatedAt
          firstAnalysisTime
          type
          sha256
          risk {
            score
          }
          sizeBytes
          status
          uploadedBy
        }
      }
      pageInfo {
        totalCount
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GET_ASSETS = gql`
  query assetsRelay($args: AssetsRelayInput!) {
    assetsRelay(args: $args) {
      edges {
        cursor
        node {
          id
          name
          vendor
          assetGroupCount
          assetGroupIds
          product
          firstAnalysisTime
          version
          createdAt
          updatedAt
          type
          sha256
          risk {
            score
          }
          sizeBytes
          status
          uploadedBy
        }
      }
      pageInfo {
        totalCount
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GET_ASSETS_OVERVIEW = gql`
  query assetsOverview($args: AssetOverviewInput!) {
    assetsOverview(args: $args) {
      edges {
        cursor
        node {
          composedAssetId
          name
          vendor
          product
          version
          submitDatetime
          operatingSystem
          operatingSystemKernelVersion
          type
          risk {
            rawScore
            score
            category
          }
        }
      }
      pageInfo {
        totalCount
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

export const GET_ASSETS_STATUSES = gql`
  query assetsStatuses($args: AssetsRelayInput!) {
    assetsRelay(args: $args) {
      edges {
        node {
          id
          updatedAt
          status
        }
      }
    }
  }
`;

export const GET_GROUP_MEMBER_STATUSES = gql`
  query assetsStatuses($args: AssetGroupMembersInput!) {
    assetGroupMembers(args: $args) {
      edges {
        node {
          id
          updatedAt
          status
        }
      }
    }
  }
`;

export const GET_ALL_ASSETS_IDS = gql`
  query allAssetsIds($args: AssetsRelayInput!) {
    assetsRelay(args: $args) {
      edges {
        node {
          id
          name
        }
      }
    }
  }
`;

export const LIST_FILES = gql`
  query listFiles($componentId: String!, $filesystemId: ID, $fileInput: FilesInput) {
    asset(args: { assetId: $componentId }) {
      filesystems(args: { filesystemId: $filesystemId }) {
        files(args: $fileInput) {
          filesList {
            file {
              digest {
                md5
                sha1
                sha256
              }
              path
              createdAt
              updatedAt
              size
              mimeType
              permissions
              hasChildren
            }
            fileId
          }
          pageInfo {
            nextPageToken
            totalSize
          }
        }
      }
    }
  }
`;

export const QL_SUBMIT_ASSET = gql`
  mutation submitAsset($fileName: String!, $args: SubmitAssetInput) {
    asset {
      submit(fileName: $fileName, args: $args) {
        uploadUrl
        uploadId
      }
    }
  }
`;

export const GET_SIGNED_URL_DOWNLOAD_FILE = gql`
  query file($args: FileDownloadInput!) {
    download {
      file(args: $args) {
        downloadUrlsList
        pathsList
      }
    }
  }
`;

export const GET_SIGNED_URL_DOWNLOAD_FILE_LIST = gql`
  query fileList($args: FileListDownloadInput!) {
    download {
      fileList(args: $args) {
        downloadUrlsList
        pathsList
      }
    }
  }
`;

export const GET_SIGNED_URL_DOWNLOAD_EXTRACTED_COMPONENT = gql`
  query extractedFirmware($args: ExtractedFirmwareDownloadInput!) {
    download {
      extractedFirmware(args: $args) {
        downloadUrlsList
        pathsList
      }
    }
  }
`;

export const GET_SIGNED_URL_DOWNLOAD_COMPONENT = gql`
  query firmware($args: FirmwareDownloadInput!) {
    download {
      firmware(args: $args) {
        downloadUrlsList
        pathsList
      }
    }
  }
`;

export const SIFT_SEARCH = gql`
  query sift($args: SiftInput!) {
    sift {
      files(args: $args) {
        hasMore
        files {
          sha256
          path
          matches {
            file
            ordinal
            similarity
            text
          }
          assets {
            componentId
            name
            product
            packages
          }
        }
      }
    }
  }
`;

export const SIFT_METRICS = gql`
  query siftCount {
    sift {
      count {
        assetCount
        fileCount
        pythonFileCount
        scriptFileCount
        textFileCount
      }
    }
  }
`;

const ACTIVITY_ENTITY_FRAGMENT = gql`
  fragment ActivityEntityFields on ActivityEntity {
    __typename
    ... on AssetCreatedPayload {
      assetType
      name
      vendor
      version
    }
    ... on AssetChangedPayload {
      assetType
      name
      vendor
      version
    }
    ... on AssetRiskChangedPayload {
      assetType
      name
      vendor
      version
      oldRisk {
        score
        category
      }
      newRisk {
        score
        category
      }
    }
    ... on IdentificationAddedPayload {
      identificationId
      name
      vendor
      version
    }
    ... on IdentificationRemovedPayload {
      identificationId
      name
      vendor
      version
    }
    ... on VulnerabilityAddedPayload {
      vulnerabilityId
      severity
      componentName
      componentVersion
      componentVendor
    }
    ... on VulnerabilityRemediatedPayload {
      vulnerabilityId
      cve
      severity
      componentName
      componentVersion
      componentVendor
      vexJustification
      description
    }
    ... on VulnerabilityUpdatedPayload {
      cve
      identificationId
    }
    ... on VulnerabilityRemovedPayload {
      cve
      identificationId
    }
    ... on VulnerabilityAddedPayload {
      cve
      identificationId
    }
    ... on MisconfigChangedPayload {
      checkId
      checkName
      oldStatus
      newStatus
    }
    ... on AssetGroupAddedPayload {
      groupId
      name
    }
    ... on AssetGroupRemovedPayload {
      groupId
      name
    }
    ... on SecretRemediatedPayload {
      secretId
      subtype
      type
      category
      filePath
      oldStatus
      newStatus
      detail
      user
    }
    ... on LicenseIssueRemediatedPayload {
      issueName
      componentId
      componentVersion
      componentName
      entityUpdates {
        field
        previous
        current
      }
    }
    ... on UnspecifiedPayload {
      payloadType
      rawData
    }
  }
`;

export const GET_ACTIVITY = gql`
  ${ACTIVITY_ENTITY_FRAGMENT}
  query activity($args: ActivityInput!) {
    activity(args: $args) {
      edges {
        cursor
        node {
          id
          correlationId
          createdAt
          entityType
          activityType
          user
          description
          entity {
            ...ActivityEntityFields
            __typename
          }
          __typename
        }
      }
    }
  }
`;
